/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */
import { u } from 'unist-builder';
/**
 * @type {Handler}
 * @param {Code} node
 */

export function code(h, node) {
  var value = node.value ? node.value + '\n' : ''; // To do: next major, use `node.lang` w/o regex, the splitting’s been going
  // on for years in remark now.

  var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
  /** @type {Properties} */

  var props = {};

  if (lang) {
    props.className = ['language-' + lang];
  }

  var code = h(node, 'code', props, [u('text', value)]);

  if (node.meta) {
    code.data = {
      meta: node.meta
    };
  }

  return h(node.position, 'pre', [code]);
}